import { WEB_STATES } from '@constants/common'
import { ROLE_TYPE } from '@constants/role'

export const ACCESS_SURFACES = {
  MAIN: 'main',
  ADMIN: 'admin'
}

export const getWebStateAccessSurface = (webState) =>
  webState === WEB_STATES.MAIN ? ACCESS_SURFACES.MAIN : ACCESS_SURFACES.ADMIN

export const getTokenAccessSurface = (user) => {
  const accessSurface = user?.accessSurface
  const identityRoleType = user?._pis?.identityRoleType
  const effectiveRoleType = user?._pis?.roleType
  const isMainIdentity = [
    ROLE_TYPE.SUPER_ADMIN,
    ROLE_TYPE.HR_ADMIN,
    ROLE_TYPE.EMPLOYEE
  ].includes(identityRoleType)
  const isAdminIdentity = [
    ROLE_TYPE.ADMIN,
    ROLE_TYPE.SUPER_ADMIN,
    ROLE_TYPE.HR_ADMIN
  ].includes(identityRoleType)

  if (
    accessSurface === ACCESS_SURFACES.MAIN &&
    effectiveRoleType === ROLE_TYPE.EMPLOYEE &&
    isMainIdentity
  ) {
    return ACCESS_SURFACES.MAIN
  }

  if (
    accessSurface === ACCESS_SURFACES.ADMIN &&
    isAdminIdentity &&
    ((identityRoleType === ROLE_TYPE.ADMIN &&
      effectiveRoleType === ROLE_TYPE.ADMIN) ||
      ([ROLE_TYPE.SUPER_ADMIN, ROLE_TYPE.HR_ADMIN].includes(identityRoleType) &&
        effectiveRoleType === ROLE_TYPE.SUPER_ADMIN))
  ) {
    return ACCESS_SURFACES.ADMIN
  }

  return undefined
}

export const canUseTokenOnWebState = (user, webState) =>
  getTokenAccessSurface(user) === getWebStateAccessSurface(webState)

export const getAuthenticatedHomePath = (user) => {
  const companyGroupCode = user?._pis?.companyGroupCode
  const accessSurface = getTokenAccessSurface(user)

  if (!accessSurface) return undefined

  return accessSurface === ACCESS_SURFACES.MAIN
    ? `/${companyGroupCode}/${user?.companyId}/dashboard`
    : `/${companyGroupCode}/self-service/login`
}
